var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9582 9.4832C24.8652 9.20547 24.6246 9.00313 24.3352 8.95859L16.65 7.78437L13.2066 0.449219C13.0777 0.175 12.8019 0 12.4992 0C12.1965 0 11.9211 0.175 11.7918 0.449219L8.34843 7.78437L0.663278 8.95898C0.373825 9.00313 0.13359 9.20586 0.0402309 9.48359C-0.0527379 9.76094 0.017184 10.0672 0.221871 10.277L5.80547 16.0023L4.48593 24.0898C4.4375 24.3852 4.56211 24.6824 4.80703 24.8543C4.9414 24.9492 5.09882 24.9973 5.25664 24.9973C5.38632 24.9973 5.51679 24.9645 5.63476 24.8996L12.4988 21.1031L19.3629 24.8996C19.4809 24.9645 19.6113 24.9973 19.741 24.9973C19.8988 24.9973 20.0566 24.9492 20.1906 24.8543C20.4355 24.6824 20.5602 24.3852 20.5117 24.0898L19.1922 16.0023L24.7758 10.277C24.9809 10.0668 25.0512 9.76055 24.9582 9.4832Z",
    fill: "#E7D532"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileStar);
export default __webpack_public_path__ + "static/media/profileStar.a9aaf7f0b69b91ce355f1d4f83adaaea.svg";
export { ForwardRef as ReactComponent };